import { render } from "./OrderNumberSection.vue?vue&type=template&id=f23b8c96&scoped=true"
import script from "./OrderNumberSection.vue?vue&type=script&lang=js"
export * from "./OrderNumberSection.vue?vue&type=script&lang=js"

import "./OrderNumberSection.vue?vue&type=style&index=0&id=f23b8c96&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f23b8c96"]])

export default __exports__